import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CognitoAuthService } from '@app/core/services/cognito-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CognitoAuthGuard implements CanActivate {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.cognitoAuthService.getCurrentUser$().then(() => true).catch(() => {
      this.router.navigate(['/account/login']);
      return false;
    });
  }
}
